import {
  customersAuthorizationApi,
  ECustomerAuthorizationEndpoints
} from '../api';
import { EGerdauService } from '../EGerdauService';

interface IMarketingCloudWebEventRequest {
  type: 'long-steel-orders' | 'fabrication-orders';
  downloadExcel?: boolean;
  rebuyOrder?: boolean;
}

export class MarketingCloudService extends EGerdauService {
  static sendEvent(request: IMarketingCloudWebEventRequest): void {
    const headers = new EGerdauService().getHeaders();
    try {
      customersAuthorizationApi.post(
        `${ECustomerAuthorizationEndpoints.SEND_MKT_CLOUD_EVENT}`,
        {
          ...request
        },
        { headers }
      );
    } catch (err) {
      console.error(err);
    }
  }
}
